import script from "./ForRentTable.vue?vue&type=script&setup=true&lang=js"
export * from "./ForRentTable.vue?vue&type=script&setup=true&lang=js"

import "./ForRentTable.vue?vue&type=style&index=0&id=3f861cb4&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3f861cb4"]])

export default __exports__